import status from '../constants/actionStatus';

const initialState = {
    dynamicSeoSettings: [],
    status: null
};

export default (state = initialState, action = {}) => {
    switch (action.type) {
    case 'GET_DYNAMIC_SEO_SETTINGS_REQUEST':
        return {
            ...state,
            status: status.PENDING
        };

    case 'GET_DYNAMIC_SEO_SETTINGS_SUCCESS':
        return {
            ...state,
            status: status.SUCCESS,
            dynamicSeoSettings: action.payload.data
        };

    case 'GET_DYNAMIC_SEO_SETTINGS_FAILURE':
        return {
            ...state,
            status: status.ERROR
        };

    default:
        return state;
    }
};
